import { defineAsyncComponent } from 'vue';

/* doc文档编辑器 */
export const docRouter = {
	path: '/onlyoffices',
	component: defineAsyncComponent(() => import('@/views/onlyoffice/Index.vue')),
	name: 'OnlyOfficeDocs',
	meta: { hidden: true },
	children: [
		{
			path: 'doceditor/:fileId/:device',
			component: defineAsyncComponent(() => import('@/views/onlyoffice/DocEditNew.vue')),
			name: 'DocEditorNew',
			meta: { title: '编辑文档2' },
		},
		{
			path: 'docview/:fileId/:device',
			component: defineAsyncComponent(() => import('@/views/onlyoffice/DocViewNew.vue')),
			name: 'DocViewNew',
			meta: { title: '文档预览2' },
		},
	],
};
